<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong style="margin-left: 0.9rem;">Request Delivery</strong>
            <div class="card-header-actions">     
              <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" style="margin-right:1.5rem" type="button"><i class="fa fa-refresh"></i></button>                 
            </div>
          </div>   
        <!--   <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                  <b-col sm="12" >
                  <b-form-group label="Delivery Agent"  :label-cols="4" >
                      <b-form-select class="form-control input" v-model="customer.deliveryagentmasterid" name="deliveryagentname" v-validate="'required|'" 
                      :class="{'input': true, 'text-danger': errors.has('form-1.deliveryagentname') }" >
                        <option :value="selected" >Select</option>
                        <option :value="customer.deliveryagentmasterid"  v-for="agent in data1" v-bind:value="agent.deliveryagentmasterid">{{ agent.deliveryagentfirstname}} {{ agent.deliveryagentlastname}}-{{ agent.deliveryagentmasterid}}</option>
                        <span style="width: 270px;" v-show="errors.has('form-1.deliveryagentname')" class="help text-danger">{{ errors.first('form-1.deliveryagentname') }}</span> 
                  </b-form-select>
                  </b-form-group>
                </b-col>
                </b-col>
                <b-col md="6" >
                 <b-button type="submit" size="md" class="mr-4" variant="primary">Search</b-button>
                </b-col>
              </b-row>               
            </form>
          </div> -->
            <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b> </p>
              </b-col>    
          <b-col sm="12" >
           <b-table show-empty stacked="md" :busy="isBusy" :items="requestitems" :fields="fields":outlined="outlined" :current-page="currentPage" :perPage="perPage":bordered="bordered"   :filter="filter" :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" >
              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div> 

               <template slot="actions" slot-scope="row">
                 <span v-if="row.item.status==='Pending'"   style="cursor:pointer;">
                    <span data-toggle="tooltip" title="Approve">
                    <span @click="markapprove(row.item)" class="badge badge-success" style="font-size: 12px;margin-left: 5px;">Approved</span>
                      <span  data-toggle="tooltip" title="Reject"> 
                    <span @click="markdecline(row.item)"  class="badge badge-danger" style="margin-left: 5px;
                    font-size: 12px;">Decline</span>
                  </span>  
                  </span>
                  
                  </span>
               </template>           
            </b-table>
          </b-col>

          <b-col md="6" class="my-1" >
        <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
             <!--  <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table">
              </b-pagination> -->
      </b-col> 
          




        </b-card>
      </b-col>
     </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      selected:'',
      name: 'allocation',
      data: [],
     
      data1: [],
     
      allocated: [],
      customer: {},
      deliveryagent:"",
      isBusy: false,
      // rows: 0,
      totalRows:0,
      currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
      // isBusy2: false,
      bordered: true,
      filter:null,
      outlined:true,
       sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      fields: [
         { key: 'requet_id', label: 'Requested Id', sortable: true, sortDirection: 'desc' },
         { key: 'shippingid', label: 'Shipping Id', sortable: true, sortDirection: 'desc' },
         { key: 'rider_name', label: 'Rider Name', sortable: true, sortDirection: 'desc' },
         { key: 'customer_name', label: 'Customer Name', sortable: true, sortDirection: 'desc' },
         { key: 'lastmodifieddate', label: 'Modified Date', sortable: true, sortDirection: 'desc' },
         { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc' },
         { key: 'updated_by', label: 'UpdatedBy', sortable: true, sortDirection: 'desc' },
         { key: 'updated_date', label: 'UpdatedDate', sortable: true, sortDirection: 'desc' },
         { key: 'status', label: 'Status', sortable: true, sortDirection: 'desc' },
         { key: 'actions', label: 'Action', sortable: true, sortDirection: 'desc' },
      ],
        requestitems: [],
     
    }
  },
  created: function() {
    this.showData()
  },
  methods: {
    // validateForm(scope) {
    //   this.$validator.validateAll(scope).then((result) => {
    //     if (result) {
    //       this.showData()
    //     }
    //   })
    // },
    onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },

 markapprove:function(value){
  
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.deliveryagent=value.deliveryagentmasterid;
      this.shipping=value.shippingid;
      this.requestid=value.requet_id;
// alert(this.deliveryagent);
        var approveObj = {
        deliveryagentmasterid: this.deliveryagent,
        shippingid:this.shipping,
        // lastmodifiedby:`${userInfo.userfirstname}`+" "+`${userInfo.userlastname}`,
        deliverystatuscode:"1",
        requestid:this.requestid,
        lastmodifiedby:`${userInfo.sysemailid}`,

      };
      // console.log("approveObj",approveObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/markdeliverystatusbyadmin`,
            approveObj
          )
          .then(result => {
            // this.actionfun(this.selected_status);
      if (result.body.returnmsg ==='Successful' ) {
            // this.$fire({
            //       text: "Shipment Delivered Successfully",
            //       type: "success",
            //       timer: 30000
            //     });
            alert("Shipment Delivered Successfully");
             this.showData();
              }
            else{
               // this.$fire({
               //    text: result.body.returnvalue,
               //    type: "error",
               //    timer: 30000
               //  });
               alert(result.body.returnvalue);
            }
          })

          .catch(ex => {
            console.log("error", ex);
          });
         
    },
    
   markdecline:function(value){
         var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.deliveryagent=value.deliveryagentmasterid;
      this.shipping=value.shippingid;
      this.requestid=value.requet_id;
// alert(this.deliveryagent);
        var declineObj = {
        // deliveryagentmasterid: this.deliveryagent,
        // shippingid:this.shipping,
        // deliverystatuscode:"1",
        requestid:this.requestid,
        lastmodifiedby:`${userInfo.sysemailid}`,

      };
      // console.log("declineObj",declineObj);
      // return false;
       this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/reject_supportrequest`,
            declineObj
          )
          .then(result => {
            // console.log("Result",result);
            // this.actionfun(this.selected_status);
      if (result.body.returnmsg ==='Successful' ) {
            // this.$fire({
            //       text: result.body.returnvalue,
            //       type: "success",
            //       timer: 30000
            //     });
            alert(result.body.returnvalue);
             this.showData();
              }
            else{
               // this.$fire({
               //    text: result.body.returnvalue,
               //    type: "error",
               //    timer: 30000
               //  });
                alert(result.body.returnvalue);
            }
          })

          .catch(ex => {
            console.log("error", ex);
          });
         
   },
    
    
   
    
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
    
      //console.log("hello"+userInfo.sysusermasterid);
     if(userInfo.sysusermasterid==25 || userInfo.sysusermasterid==39)
     {
     
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        usertype:'4',

      }
 this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body
          this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
     }
   
     else
     {
      let customerGetobj = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'

      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
        .then((result) => {
          this.data1 = result.body
          this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    }
 
      
    },
    GetSortOrder : function(prop) {
        return function(a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        }

    },
    showData: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isBusy = true;
      // this.isBusy2 = true;
      const obj = {}
     this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/get_supporttickets`,obj)
        .then((result) => {
          if (result.body.returnmsg == 'Successful') {
            this.isBusy = !this.isBusy
            this.requestitems  = result.body.returnvalue;
            this.totalRows = result.body.returnvalue.length;
          } else {
            this.isBusy = !this.isBusy
            this.requestitems  = [];
            // this.rows=0;
            this.totalRows = 0;
          }
        
         
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    
    },

     refresh:function() {
      this.showData();
    },

  }, 
};
</script>

